import { type StaticColumn } from 'src/app/services/labpartner.service.model';

export class ConditionColumns {
  static lodColumns: StaticColumn[] = [
    {
      prop: 'cartridgeLot',
      header: 'Cartridge Lot',
      required: true,
    },
  ];

  static generalColumns: StaticColumn[] = [
    {
      prop: 'name',
      header: 'Name',
      required: true,
    },
    {
      prop: 'cartridgeLot',
      header: 'Cartridge Lot',
    },
  ];

  static dailyExternalControlsColumns: StaticColumn[] = [
    {
      prop: 'cartridgeLot',
      header: 'Cartridge Lot',
      required: true,
    },
    {
      prop: 'testingDate',
      header: 'TestingDate',
      required: true,
      isCustom: true,
      valueType: 'date',
      inputType: 'date',
    },
  ];

  static precisionColumns: any[] = [
    {
      prop: 'precisionDay',
      header: 'Precision Day',
      required: true,
      inputType: 'number',
    },
    {
      prop: 'cartridgeLot',
      header: 'Cartridge Lot',
      required: true,
    },
    {
      prop: 'precisionEvent',
      header: 'Precision Event',
      required: true,
      inputType: 'number',
    },
  ];

  static intSubsColumns: any[] = [
    {
      prop: 'intSubsName',
      header: 'Interfering Substance Name',
      required: true,
    },
    {
      prop: 'intSubsPartNumber',
      header: 'Interfering Substance Part Number',
      required: true,
    },
    {
      prop: 'intSubsLotNumber',
      header: 'Interfering Substance Lot Number',
      required: true,
    },
    {
      prop: 'intSubsActiveIngredient',
      header: 'Interfering Substance Active Ingredient',
      required: true,
    },
    {
      prop: 'intSubsConcentration1x',
      header: 'Interfering Substance Concentration Value',
      isCustom: true,
      inputType: 'number',
      valueType: 'scientific',
      required: true,
      minValue: 0,
    },
    {
      prop: 'intSubsConcentration1xUnit',
      header: 'Interfering Substance Concentration Unit',
      required: true,
    },
    {
      prop: 'intSubsCartridgeLot',
      header: 'Cartridge Lot',
      required: false,
    },
  ];

  // Cross Reactivity and Microbial Interference
  static crossReactivityAndMicrobialInterferenceAnalyteColumns: any[] = [
    {
      prop: 'crmiConditionMicrobeName',
      header: 'Microbe Name',
      required: true,
    },
    {
      prop: 'crmiConditionMicrobeSource',
      header: 'Microbe Source',
      required: true,
    },
    {
      prop: 'crmiConditionMicrobePartNumber',
      header: 'Microbe Part Number',
      required: true,
    },
    {
      prop: 'crmiConditionMicrobeLotNumber',
      header: 'Microbe Lot Number',
      required: true,
    },
    {
      prop: 'crmiConditionMicrobeConcentration1x',
      header: 'Microbe Concentration Value',
      required: true,
      isCustom: true,
      inputType: 'number',
      valueType: 'scientific',
    },
    {
      prop: 'crmiConditionMicrobeConcentration1xUnit',
      header: 'Microbe Concentration Unit',
      required: true,
    },
    {
      prop: 'crmiConditionCartridgeLot',
      header: 'Cartridge Lot',
      required: false,
    },
  ];

  // Transport Media and Specimen Stability
  static transportMediaAndSpecimenStabilityColumns: any[] = [
    {
      prop: 'tmssConditionStorageCondition',
      header: 'Storage Condition',
      required: true,
    },
    {
      prop: 'tmssConditionTimepointValue',
      header: 'Timepoint Value',
      required: true,
      inputType: 'number',
      valueType: 'number',
    },
    {
      prop: 'tmssConditionTimepointUnit',
      header: 'Timepoint Unit',
      isCustom: true,
      required: true,
      inputType: 'select',
      options: [
        { value: '0', label: 'Hours' },
        { value: '1', label: 'Days' },
        { value: '2', label: 'Cycles' },
      ],
      valueType: 'number',
    },
    {
      prop: 'tmssConditionCartridgeLot',
      header: 'Cartridge Lot',
      required: false,
    },
    {
      prop: 'tmssConditionAliquot',
      header: 'Aliquot',
      required: false,
      inputType: 'number',
      valueType: 'number',
    },
  ];
}
